<div *mobxAutorun="{}">
  <div class="header-container">
    <div
      *ngFor="let item of steps; let i = index"
      class="progress-step-item"
      style="width: 30%"
      [class.float-right]="i == 1"
      [class.opacity-10]="hideDropOff && item.schedule && item.schedule.isDropOff"
    >
      <div
        *ngIf="item.name"
        class="progress-step-item-title"
        [class.pick-up]="!item.schedule.isDropOff"
        [class.drop-off]="item.schedule.isDropOff"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
  <div class="progress-line-container">
    <div
      *ngFor="let item of steps; let i = index"
      class="progress-step-item"
      style="width: 50%"
      [class.opacity-10]="hideDropOff && item.schedule && item.schedule.isDropOff"
    >
      <div class="progress-line"></div>
      <!--            <div class="left-progress" *ngIf="i > 0"></div>-->
      <!--            <div class="right-progress" *ngIf="i < steps.length - 1"></div>-->
      <span class="progress-step-item-number" [style.left]="i == 0 ? '-20%' : '20%'"></span>
    </div>
  </div>
  <div class="date-container">
    <span
      *ngFor="let item of steps; let i = index"
      class="progress-step-item text-gray-800"
      [class.float-right]="i == 1"
      [class.opacity-10]="hideDropOff && item.schedule && item.schedule.isDropOff"
      style="width: 30%"
    >
      <ng-container *ngIf="item.schedule">
        <!--                <ng-container *ngIf="!(item.schedule.isDropOff && hideDropOff) else datePlaceHolder;">-->
        <span class="mt-2">{{ item.schedule.scheduledTime | datex : "ddd DD MMM 'YY" }}</span>
        <br />
        <span class="mt-2">{{
          item.schedule.scheduledTime.getHours() | hourBand : item.schedule.isDropOff
        }}</span>
        <br />
        <span
          [ngClass]="{
            'text-green-600': item.schedule.isScheduledTimeInWindow,
            'text-orange-600': !item.schedule.isScheduledTimeInWindow
          }"
          >{{ item.schedule.validationText }}</span
        >
        <br />
        <span
          *ngIf="
            taskSupplierScheduleStore.pickUp.selectedTravelModeOption && !item.schedule.isDropOff
          "
        >
          {{ taskSupplierScheduleStore.pickUp.selectedTravelModeOption.title }} to pick-up location
        </span>
        <!--                </ng-container>-->
      </ng-container>
      <ng-template #datePlaceHolder>
        <span class="mt-2">--</span>
        <br />
        <span class="mt-2">--</span>
        <br />
        <div class="w-full flex align-items-end justify-content-center">
          <!--                    <i class="pi mr-1" [ngClass]="{ 'pi-check text-green-600': item.isInWindow, 'pi-exclamation-triangle text-orange-600': !item.isInWindow }"></i><br/>-->
          <span->--</span->
        </div>
      </ng-template>
    </span>
  </div>
</div>
